import { render } from "./AgeGrades.vue?vue&type=template&id=7ce7cb71"
import script from "./AgeGrades.vue?vue&type=script&lang=js"
export * from "./AgeGrades.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__